<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <el-col :span="3" :xs="24">
          <SearchByMemberAndCard2 ref="SearchByMemberAndCard2" />
        </el-col>
        <el-col :span="3" :xs="24">
          <el-form-item prop="thirdPartyOrderId">
            <el-input
              v-model="params.orderSn"
              maxlength="32"
              placeholder="订单单号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="24">
          <el-form-item prop="huifuBackOrderNum">
            <el-input
              v-model="params.huifuBackOrderNum"
              placeholder="充值单号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="24">
          <el-form-item prop="groupId">
            <el-select
              v-model="params.groupId"
              filterable
              :loading="loading"
              placeholder="输入小区名称"
            >
              <el-option
                v-for="item in groupList"
                :key="item.id"
                :label="item.groupName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="24">
          <el-form-item prop="carPortId">
            <el-select
              v-model="params.carPortId"
              filterable
              :loading="loading"
              placeholder="输入车库名称"
            >
              <el-option
                v-for="item in carportList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!--        <el-col :span="5" :xs="24">-->
        <!--          <el-form-item prop="memberId">-->
        <!--            <el-select v-model="params.memberId"-->
        <!--                       :loading="userLoad"-->
        <!--                       :remote-method="getUserList"-->
        <!--                       filterable-->
        <!--                       placeholder="输入手机号选择用户"-->
        <!--                       remote-->
        <!--                       id="el-select"-->
        <!--                       @focus="closeReadOnly"-->
        <!--                       @hook:mounted="closeReadOnly"-->
        <!--                       @visible-change="closeReadOnly"-->
        <!--                       reserve-keyword>-->
        <!--              <el-option-->
        <!--                  v-for="item in userList"-->
        <!--                  :key="item.value"-->
        <!--                  :label="item.nickName"-->
        <!--                  :value="item.id">-->
        <!--                <img :src="item.headImage" alt="" class="img">-->
        <!--                <span style="margin-left: 10px">{{ item.nickName }}</span>-->
        <!--                <span style="margin-left: 10px">{{ item.money }}</span>-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--          </el-form-item>-->

        <!--        </el-col>-->
        <el-col :span="5" :xs="24">
          <!-- <el-date-picker
              v-model="time"
              :clearable="false"
              :picker-options="pickerOptions"
              end-placeholder="结束日期"
              range-separator="至"
              start-placeholder="开始日期"
              type="daterange"
              value-format="timestamp"/> -->
          <lp-date-picker
            ref="lpDatePicker"
            @finish="handleLpDatePickerChange"
          />
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>
    <div style="display: flex; justify-content: flex-end; padding: 5px">
      <el-button
        type="primary"
        icon="el-icon-upload2"
        @click="handleExportTableBtnClick"
        >导出</el-button
      >
    </div>
    <el-table
      id="exportTab"
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
    >
      <el-table-column width="100" label="订单号" prop="orderSn">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="scope.row.orderSn"
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{ scope.row.orderSn }}
            </div>
          </el-tooltip>
          <!-- <el-popover
            placement="top-start"
            title="订单号:"
            :width="290"
            trigger="hover"
            :content="scope.row.orderSn"
          >
            <template #reference>
              <span>{{ scope.row.orderSn }}</span>
            </template>
          </el-popover> -->
        </template>
      </el-table-column>
      <el-table-column width="100" label="充值单号" prop="huifuBackOrderNum">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="scope.row.huifuBackOrderNum"
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{ scope.row.huifuBackOrderNum }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="包月类型" width="100">
        <template #default="scope">
          {{
            Array.isArray(scope.row.orderType)
              ? "充电+停车"
              : scope.row.orderType == 3
              ? "充电"
              : scope.row.orderType == 4
              ? "只停车"
              : ""
          }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="用户昵称" width="160">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="scope.row.memberInfo ? scope.row.memberInfo.name : ''"
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{ scope.row.memberInfo && scope.row.memberInfo.name }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column> -->
      <el-table-column label="手机号/电卡" prop="memberInfo.phone" width="110">
        <template #default="scope">
          {{
            scope.row.memberInfo
              ? scope.row.memberInfo.phone == 0
                ? "未绑定"
                : scope.row.memberInfo.phone
              : "未绑定"
          }}</template
        >
      </el-table-column>

      <el-table-column
        label="用户类型"
        prop="memberType"
        width="90"
        align="center"
      >
        <template #default="scope">
          <template v-if="scope.row.memberType == '1'"> 微信 </template>
          <template v-else-if="scope.row.memberType == '7'"> 支付宝 </template>
          <template v-else-if="scope.row.memberType == '3'"> 电卡 </template>
        </template>
      </el-table-column>
      <!-- <el-table-column width="280" label="订单号" prop="orderSn"/> -->
      <el-table-column width="140" label="小区名称" prop="remark">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="scope.row.remark"
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{ scope.row.remark }}
            </div>
          </el-tooltip>
          <!-- <el-popover
            placement="top-start"
            title="包月名称:"
            :width="200"
            trigger="hover"
            :content="scope.row.monthlyName"
          >
            <template #reference>
              <span>{{ scope.row.monthlyName }}</span>
            </template>
          </el-popover> -->
        </template>
      </el-table-column>

      <el-table-column label="充电时长" prop="freeChargeNum" width="80" />
      <el-table-column label="充电到期" prop="timeLen" width="140">
        <template #default="scope">
          <template v-if="scope.row.chargeEndTime">
            {{ parseFormatDay(new Date(scope.row.chargeEndTime * 1000)) }}
          </template>
          <template v-if="scope.row.timeLen">
            ({{ scope.row.timeLen }}天)
          </template>
        </template>
      </el-table-column>
      <el-table-column label="停车到期" prop="dayNum" width="140">
        <template #default="scope">
          <template v-if="scope.row.parkEndTime">
            {{ parseFormatDay(new Date(scope.row.parkEndTime * 1000)) }}
          </template>
          {{ scope.row.dayNum ? "(" + scope.row.dayNum + "天)" : "" }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="所属车库" width="160" align="center">
        <template #default="scope">
          {{ scope.row.carport ? scope.row.carport.name : "" }}
        </template>
      </el-table-column> -->

      <el-table-column width="115" label="所属车库">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="scope.row.carport ? scope.row.carport.name : ''"
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{ scope.row.carport ? scope.row.carport.name : "" }}
            </div>
          </el-tooltip>
          <!-- <el-popover
            placement="top-start"
            title="所属车库:"
            :width="200"
            trigger="hover"
            :content="scope.row.carport ? scope.row.carport.name : ''"
          >
            <template #reference>
              <span>{{ scope.row.carport ? scope.row.carport.name : "" }}</span>
            </template>
          </el-popover> -->
        </template>
      </el-table-column>

      <el-table-column width="115" label="车辆类型">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="
              scope.row.memberCar && scope.row.memberCar.carType
                ? scope.row.memberCar.carType.name
                : ''
            "
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{
                scope.row.memberCar && scope.row.memberCar.carType
                  ? scope.row.memberCar.carType.name
                  : ""
              }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>

      <!-- <el-table-column label="最大功率" min-width="100" prop="maxPower">
        <template #default="scope"> {{ scope.row.maxPower }}W </template>
      </el-table-column> -->

      <el-table-column label="金额(元)" prop="money" width="80">
        <template #default="scope"> {{ scope.row.money }} </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="100" prop="creatTime">
        <template #default="scope">
          {{ timeFormat(scope.row.creatTime) }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="当月可用" width="100">
        <template #default="scope">
          {{ getCurrMonthDays(scope.row) }}天
        </template>
      </el-table-column>
      <el-table-column label="下月可用" width="100">
        <template #default="scope">
          {{ getNextMonthDays(scope.row) }}天</template
        >
      </el-table-column> -->
      <el-table-column label="付款方式" prop="payType">
        <template #default="scope">
          <template v-if="scope.row.payType == '1'"> 微信支付 </template>
          <template v-else-if="scope.row.payType == '2'"> 支付宝 </template>
          <template v-else-if="scope.row.payType == '3'"> 运营商代充 </template>
          <template v-else-if="scope.row.payType == '4'"> 管理员代充 </template>
        </template>
      </el-table-column>
      <el-table-column label="支付类型" prop="payState">
        <template #default="scope">
          <template v-if="getPaySuccess(scope.row)"> 付款成功 </template>
          <template v-else> 未支付 </template>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="125">
        <template #default="scope">
          <template
            v-if="
              getIsCanRefund(scope.row) &&
              !getIsUnsubscribe(scope.row) &&
              (scope.row.payType == '2' || scope.row.payType == '1')
            "
          >
            <el-button
              v-if="scope.row.money > 0"
              type="danger"
              @click="refundOrder(scope.row)"
              >退单
            </el-button>
          </template>
          <template v-else-if="getIsUnsubscribe(scope.row)">
            <span>已退单</span>
          </template>
          <template v-else>
            <span>不可退单</span>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total" />
    <OrderDetailsDialog :id="id" :dialog="orderDetailsDialog" />
    <finish-order-dialog :id="id" :dialog="finishOrderDialog" />
    <wave-dialog :id="id" :dialog="waveDialog" />
    <refundCarportAndChargeMonthlyOrderDialog
      :orderObj="orderObj"
      :dialog="refundCarportAndChargeMonthlyOrderDialog"
    />
  </div>
</template>

<script>
// import MemberMonthlyLogController from "@/api/device/MemberMonthlyLogController";
import FinishOrderDialog from "@/components/Dialog/finishOrderDialog";
import OrderDetailsDialog from "@/components/Dialog/orderDetailsDialog";
import refundCarportAndChargeMonthlyOrderDialog from "@/components/Dialog/refundCarportAndChargeMonthlyOrderDialog";
import WaveDialog from "@/components/Dialog/waveDialog";
import Page from "@/components/Page";
import SearchByMemberAndCard2 from "@/components/SearchByMemberAndCard2";
import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import getDeviceMixin from "@/mixin/getDeviceMixin";
import getUserMixin from "@/mixin/getUserMixin";
import pageMixin from "@/mixin/pageMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";
// import UserInfoStore from "@/utils/UserInfoStore";
import agentGetCarportByPage from "@/api/device/carport-controler/agentGetCarportByPage";
import agentGetGroupListByPage from "@/api/device/device-group-manage/agentGetGroupListByPage";
import agentGetAllMontylyOrderLogs from "@/api/fund/order-manage/agentGetAllMontylyOrderLogs";
import { exportTableToExcel } from "@/utils/exportTable";

export default {
  name: "RechargeOrder",
  components: {
    WaveDialog,
    FinishOrderDialog,
    OrderDetailsDialog,
    Page,
    SearchByMemberAndCard2,
    refundCarportAndChargeMonthlyOrderDialog,
  },
  mixins: [
    pageMixin,
    createdMixin,
    timeMixin,
    searchMixin,
    dialogMixin,
    getDeviceMixin,
    getUserMixin,
  ],
  data() {
    return {
      waveDialog: false,
      id: undefined,
      finishOrderDialog: false,
      orderDetailsDialog: false,
      refundCarportAndChargeMonthlyOrderDialog: false,
      time: [],
      records: [],
      params: {
        phone: undefined,
        pageNum: undefined,
        size: undefined,
        startTime: undefined,
        endTime: undefined,
        memberType: undefined,
        memberId: undefined,
        orderSn: undefined,
        groupId: undefined,
        carPortId: undefined,
        sortName: "id",
        sortType: "DESC",
      },
      orderObj: {
        orderSn: undefined,
        orderType: undefined,
      },
      carportList: [],
      groupList: [],
      loading: false,
    };
  },
  created() {
    this.getMyGroupList();
    this.getMyCarportList();
  },
  methods: {
    getPaySuccess(row) {
      if (Array.isArray(row.orderType) || row.orderType == "4") {
        // return row.payState == 1;
        return row.payState == 1 || row.payState == -2;
      } else {
        return row.state == 1;
      }
    },
    getIsCanRefund(row) {
      if (Array.isArray(row.orderType) || row.orderType == "4") {
        return row.payState == 1;
      } else {
        return row.state == 1;
      }
    },
    getIsUnsubscribe(row) {
      return row.orderType == "4" ? row.payState == -2 : row.unsubscribe == 2;
    },
    // 获取包月当月剩余可用天数
    // getCurrMonthDays(row) {
    //   const date = new Date(row.creatTime * 1000);
    //   // 获取包月开始当日天数
    //   const startDay = date.getDate();
    //   // 获取当月总共天数
    //   const totalDay = new Date(
    //     date.getFullYear(),
    //     date.getMonth() + 1,
    //     0
    //   ).getDate();

    //   return totalDay - startDay + 1;
    // },
    // // 获取包月下月剩余可用天数
    // getNextMonthDays(row) {
    //   console.log(this.getCurrMonthDays(row));
    // },
    getMyGroupList() {
      agentGetGroupListByPage(1, 99999, {}).then((res) => {
        this.groupList = res.data.records;
      });
    },
    getMyCarportList() {
      agentGetCarportByPage({
        pageNum: 1,
        size: 99999,
      }).then((res) => {
        this.carportList = res.data.records;
      });
    },
    handleExportTableBtnClick() {
      exportTableToExcel(
        "exportTab",
        ["金额(元)", "充电时长"],
        "包月记录.xlsx"
      );
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }

      this.fetchData();
    },
    resetFields() {
      this.params = {
        phone: undefined,
        pageNum: undefined,
        size: undefined,
        startTime: undefined,
        endTime: undefined,
        memberType: undefined,
        memberId: undefined,
        orderSn: undefined,
        sortName: "id",
        sortType: "DESC",
      };
    },
    closeReadOnly(val) {
      this.$nextTick(() => {
        if (!val) {
          const timer = setTimeout(() => {
            document.getElementById("el-select").removeAttribute("readonly");
            clearTimeout(timer);
          }, 200);
        }
      });
    },
    refundOrder(row) {
      // this.id = id;
      this.$set(this.orderObj, "orderSn", row.orderSn || row.orderSh);
      this.$set(
        this.orderObj,
        "orderType",
        Array.isArray(row.orderType) ? row.orderType : [row.orderType]
      );
      this.refundCarportAndChargeMonthlyOrderDialog = true;
    },
    wave(id) {
      this.id = id;
      this.waveDialog = true;
    },
    detail(id) {
      this.id = id;
      this.orderDetailsDialog = true;
    },
    finish(id) {
      this.id = id;
      this.finishOrderDialog = true;
    },
    fetchData() {
      this.loadTable = true;
      this.params.pageNum = this.current;
      this.params.size = this.size;

      // if (UserInfoStore.getInfo() && UserInfoStore.getInfo().id == 68)
      //   this.params.agentId = 68;

      agentGetAllMontylyOrderLogs(this.params)
        .then((res) => {
          const resultMap = new Map();
          this.records = res.data.records.map((r) => {
            const obj = {
              ...r.sourceOrder,
              orderType: r.orderType,
              memberInfo: r.memberInfo,
              orderSn: r.orderSn,
              huifuBackOrderNum: r.huifuBackOrderNum,
              payType: r.payType,
            };

            // 设置充电，停车到期时间
            if (r.orderType == 3) {
              obj.chargeEndTime = r.sourceOrder.endTime || 0;
            } else if (r.orderType == 4) {
              obj.parkEndTime = r.sourceOrder.endTime || 0;
            }

            return obj;
          });

          // 合并相同id数据，设置订单类型为充电+停车
          this.records.forEach((item) => {
            if (resultMap.has(item.orderSn)) {
              resultMap.set(item.orderSn, {
                ...resultMap.get(item.orderSn),
                ...item,
                money: resultMap.get(item.orderSn).money + item.money,
                orderType: [
                  resultMap.get(item.orderSn).orderType,
                  item.orderType,
                ],
                huifuBackOrderNum:
                  item.huifuBackOrderNum ||
                  resultMap.get(item.orderSn).huifuBackOrderNum,
              });
            } else {
              resultMap.set(item.orderSn, item);
            }
          });
          this.records = Array.from(resultMap.values());

          this.total = res.data.total;
          // this.records = res.data.records;
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
  },
};
</script>
<style scoped>
.img {
  width: 30px;
  height: 30px;
}
</style>
